export const NOTIFICATION_SETTINGS = {
  system: {title: 'System', description: 'Important changes to your service'},
  account: {title: 'Account', description: 'Stay updated on your account activity'},
  billing: {title: 'Billing', description: 'Billing cycle updates and alerts'},
  security: {title: 'Security', description: 'Keep your account safe'},
  content: {title: 'Content', description: 'Stay informed of our latest industry insights'},
  promotional: {title: 'Promotional', description: 'Exclusive seals just for you'},
  features: {title: 'Features', description: 'Discover new tools and features'},
}